module.exports = __webpack_public_path__ + "img/30.2a0e3ccb.svg";